import getUnixTime from 'date-fns/getUnixTime';
import endOfDay from 'date-fns/endOfDay';
import startOfDay from 'date-fns/startOfDay';
import subDays from 'date-fns/subDays';

// Injection key shared between LiveReports.vue (provider) and the
// period-based Overview containers (injectors) for the global date-range
// filter. A Symbol avoids typos across the ~7 consumer files.
export const OVERVIEW_DATE_FILTER_KEY = Symbol('overviewDateFilter');

// Same last-7-days default LiveReports.vue seeds the real filter with —
// reused as inject()'s fallback factory so a container never crashes on
// dateFilter.from being undefined if it's ever mounted without the provider
// (e.g. a future standalone usage), instead of trusting the provider blindly.
export const createDefaultDateFilter = () => {
  const until = endOfDay(new Date());
  const since = startOfDay(subDays(until, 6));
  return {
    from: getUnixTime(since),
    to: getUnixTime(until),
    businessHours: false,
  };
};
